import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useLocation, useNavigate } from "react-router-dom";
import Footerdeo from "../shared/Footerdeo";
// import { Modal, Button, Nav, Tab } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import config from "../../config";
import { Link } from "react-router-dom";
import StudentDetailsModal from "./StudentDetailsModal";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const TotalApprovedApplicant = ({ school }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const deO_ID = sessionStorage.getItem("deoId");
  const school_code = sessionStorage.getItem("school_code");
  const token = sessionStorage.getItem("deotoken");
  const location = useLocation();
  const schoolCode = location.state?.school?.schooL_CODE;
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  // ============ Fetching Demography Data =============
  const handleModalOpen = async (stu) => {
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/FetchDEODemographyData_CL9`,
        {
          candidatE_ID: stu.candidatE_ID,
          schooL_CODE: schoolCode,
          districtcode: sessionStorage.getItem("deoId"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedStudent(response.data.data["deoDemography_data"] || {});

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student demography data", error);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  // ============ Fetching Approved Applicant List =============

  const fetchApprovedDetails = async () => {
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/DEOApprovedCheckDetails_CL9`,
        {
          deO_ID,
          schooL_CODE: schoolCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status === 200) {
        setRows(response.data.data.approvedDEO_status || []);
      } else {
        console.warn("API returned non-200 status", response.data);
        setRows([]);
      }
    } catch (err) {
      console.error("API error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!schoolCode) {
      navigate("/deo-total-approved");
    }
    fetchApprovedDetails();
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredStudents = rows.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.candidatE_ID?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="container-scroller d-flex flex-column min-vh-100">
        <Navbardeo />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper flex-grow-1 d-flex">
          <Sidebardeo />
          <div className="main-panel d-flex flex-column flex-grow-1">
            {/* ======= Content Wrapper ======= */}
            <div className="content-wrapper bg-light flex-grow-1 overflow-auto">
              {/* ======= Breadcrumb + Heading ======= */}
              <div className="container-fluid mt-3 px-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h3>Total Approved Applicant</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item active">
                        {" "}
                        <Link
                          to="/deo-dashboard"
                          style={{ textDecoration: "none", color: "grey" }}
                        >
                          {" "}
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: "5px" }}
                          ></i>
                          Home
                        </Link>
                      </li>
                      <li className="">Total Approved Applicant</li>
                    </ol>
                  </nav>
                </div>
              </div>

              {/* ======= Table ======= */}
              <div className="container-fluid px-4">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <div style={{ width: "250px" }}>
                          <select
                            id="rowsPerPage"
                            className="form-select form-control-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{
                              width: "80px", // or adjust as needed (80–120px)
                              paddingRight: "2rem", // ensures space for the dropdown arrow
                            }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* Search on the right */}
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                    <table
                      id="pendingApplicantsTable"
                      className="table table-bordered table-striped table-sm"
                    >
                      <thead className="table-light">
                        <tr>
                          {/* <th>
                              <input type="checkbox" disabled />
                            </th> */}
                          <th>Sl. No</th>
                          <th>Candidate ID</th>
                          <th>Candidate Name</th>
                          <th>Date of Birth</th>
                          <th>Father's Name</th>
                          <th>Mother's Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((stu, idx) => (
                            <tr key={stu.candidatE_ID || idx}>
                              {/* <td>
                                  <input type="checkbox" disabled />
                                </td> */}
                              <td>{indexOfFirstItem + idx + 1}</td>
                              <td>{stu.candidatE_ID}</td>
                              <td>{stu.candidatE_NAME}</td>
                              <td>{stu.dob.split(" ")[0]}</td>
                              <td>{stu.fatheR_NAME}</td>
                              <td>{stu.motheR_NAME}</td>
                              <td>
                                <span
                                  className={`badge bg-${
                                    stu.deO_STATUS === "APPROVED"
                                      ? "success"
                                      : stu.deO_STATUS === "REJECTED"
                                      ? "danger"
                                      : "warning"
                                  } text-white`}
                                >
                                  {stu.deO_STATUS}
                                </span>
                              </td>
                              <td>
                                <div>
                                  <button
                                    className="btn btn-primary btn-sm mb-1"
                                    onClick={() => handleModalOpen(stu)}
                                  >
                                    View Details
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center text-muted">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ======= Student Modal ======= */}
            {showModal && selectedStudent && (
              <StudentDetailsModal
                show={showModal}
                handleClose={handleModalClose}
                studentData={selectedStudent}
              />
            )}

            {/* ======= Footer ======= */}
            <div className="bg-white shadow-sm">
              <Footerdeo />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalApprovedApplicant;
